import * as React from "react";
import Repositories from "./Repositories";

const RepositoriesContext = React.createContext<Repositories | null>(null);
export default RepositoriesContext;
